import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards";

export default function CuraçaoJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Curaçao as a Jurisdiction"
                subtitle="A Global Leader in Online Gaming & iGaming Licensing"
                description="Curaçao, part of the Dutch Caribbean, has been one of the most popular jurisdictions for iGaming operators since the 1990s. Known for its cost-effective and flexible licensing, it has served as a global hub for online casinos, sports betting, and gaming platforms. With the introduction of the National Ordinance for Games of Chance (LOK) and the Curaçao Gaming Authority (CGA) in 2023, the jurisdiction is transitioning to a modern, EU-compliant regulatory framework, enhancing credibility while maintaining affordability."
                badges={[
                    "iGaming Licenses",
                    "Sports Betting",
                    "Casino Operators",
                    "Esports Platforms"
                ]}
                buttonText="Request a Curaçao Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/curacao-jurisdiction.png')}
                imageAlt="Curaçao iGaming & Online Gaming Licensing"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Curaçao?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "World’s Oldest iGaming License",
                                        text: "Trusted since the 1990s."
                                    },
                                    {
                                        title: "Regulatory Upgrade (2023+)",
                                        text: "New CGA framework replacing master licenses."
                                    },
                                    {
                                        title: "Cost-Effective",
                                        text: "Significantly lower entry costs than Malta or Isle of Man."
                                    },
                                    {
                                        title: "All-in-One License",
                                        text: "Covers casino, sports betting, esports, and more."
                                    },
                                    {
                                        title: "Crypto-Friendly",
                                        text: "License supports crypto payments and operators."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Licenses in Curaçao"
                        blocks={[
                            {
                                title: "iGaming Operator License",
                                items: [
                                    { text: "Covers online casinos, sports betting, poker, and esports." },
                                    { text: "Regulated by the Curaçao Gaming Authority (CGA)." }
                                ]
                            },
                            {
                                title: "B2B Supplier License (New LOK Framework)",
                                items: [
                                    { text: "For software providers, payment processors, and platform suppliers." },
                                    { text: "Enhances recognition of Curaçao as a full-spectrum gaming hub." },
                                    { text: "Note: Old Master/Sub-license model is being phased out — all existing licenses must transition to the new CGA system." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={[
                            {
                                title: "Capital Requirement",
                                text: "No heavy minimum capital (unlike Malta)."
                            },
                            {
                                title: "Entity",
                                text: "Curaçao company required."
                            },
                            {
                                title: "Resident Presence",
                                text: "Local representative or director needed."
                            },
                            {
                                title: "Compliance",
                                text: "AML/KYC procedures required, especially for crypto operators."
                            },
                            {
                                title: "Audit",
                                text: "Annual reporting to CGA required."
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of Curaçao as a Jurisdiction'
                        services={[
                            {
                                title: "Recognition",
                                text: "One of the most widely known iGaming licenses."
                            },
                            {
                                title: "Transitioning to EU Standards",
                                text: "Credibility is increasing under the new CGA framework."
                            },
                            {
                                title: "Crypto Integration",
                                text: "Popular with blockchain casinos and betting platforms."
                            },
                            {
                                title: "Flexible Licensing",
                                text: "Covers multiple products under a single license."
                            },
                            {
                                title: "Lower Barriers",
                                text: "Faster and cheaper than Malta or Isle of Man."
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={[
                            {
                                title: "Pre-Application Consultation",
                                text: "Define operator or supplier model."
                            },
                            {
                                title: "Entity Incorporation",
                                text: "Register a Curaçao company."
                            },
                            {
                                title: "Application Preparation",
                                text: "Prepare business plan, AML/KYC manuals, and technical setup."
                            },
                            {
                                title: "CGA Review",
                                text: "Due diligence on directors and shareholders."
                            },
                            {
                                title: "License Approval",
                                text: "Typically 3–6 months under the new framework."
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "3–6 months."
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 35,000+."
                            },
                            {
                                name: "Annual Costs",
                                description: "Regulator fees, compliance audits, IT security."
                            }
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={[
                            { text: "Over a decade of experience in Curaçao iGaming licensing." },
                            { text: "Assistance with new CGA applications & old sub-license migration." },
                            { text: "Partnerships with platform providers, PSPs, and compliance firms." },
                            { text: "Comparative insights: Curaçao vs Malta vs Isle of Man vs Anjouan." },
                            { text: "Long-term compliance support under the new framework." }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for a Tier-1 financial hub with global recognition?"
                        description="Mauritius offers banking, brokerage, funds, fintech, insurance, and crypto licensing, regulated by FSC & BoM."
                        buttonText="Book a Mauritius Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What changed in Curaçao’s gaming law in 2023?",
        answer: "The old Master/Sub-license model is being replaced by a direct license system under the CGA."
    },
    {
        question: "Can Curaçao licenses cover crypto casinos?",
        answer: "Yes — crypto operators are welcome, provided AML/KYC compliance."
    },
    {
        question: "How long does licensing take?",
        answer: "3–6 months under the new rules."
    },
    {
        question: "Why choose Curaçao over Malta?",
        answer: "Curaçao is faster and cheaper, while Malta is more prestigious but costlier."
    },
    {
        question: "Will old licenses remain valid?",
        answer: "Yes, but they must transition to the new CGA framework."
    }
];

const testimonialsData = [
    {
        quote: "We migrated our old sub-license to a CGA-issued license with Offshore Advisory’s help. Smooth and professional.",
        author: "Leo K.",
        role: "Casino Operator"
    },
    {
        quote: "Curaçao licensing let us launch our crypto casino at a fraction of Malta’s cost. Offshore Advisory managed the full setup.",
        author: "Sofia D.",
        role: "iGaming Entrepreneur"
    }
];
